import React, {useState} from 'react';
import {CustomContainer, Header, TextField} from '../../../../common';
import {useLanguageContext, useThemeContext} from '../../../../../context';
import {Col, Row} from 'react-bootstrap';
import {toSnakeCase, validateCreateTeamForm, validateSendEmailForm} from '../../../../../constants';
import {useNavigate} from 'react-router-dom';
import {sendUserCredentials} from '../../../../../api';

const SendEmail = () => {
    const {I18n} = useLanguageContext();
    const {theme} = useThemeContext();
    let navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [loading, setLoading] = useState('');
    const [errors, setErrors] = useState({});

    const handleSend = async () => {
        try {
            setLoading(true);
            let emailFormObj = {
                email,
            };

            const formErrors = await validateSendEmailForm(emailFormObj);
            console.log('form Errors', formErrors);
            setErrors(formErrors);

            if (Object.keys(formErrors).length > 0) return;

            const user = JSON.parse(localStorage.getItem('created_user'));
            console.log('user iss', user);
            const userCred = {
                username: user.username,
                password: user.password,
                pin: user.posPin,
                role: user.userRole,
                location: user.location,
                email,
                phone,
            };
            const response = await sendUserCredentials(userCred);
            localStorage.removeItem('created_user');
            console.log('response', response);
            navigate('/team');
        } catch (error) {
            console.log('something went wrong');
        } finally {
            setLoading(false);
        }
    };

    const backAction = () => {
        navigate('/team');
    };

    const onChange = async (label, value) => {
        if (label === I18n.enter_email_address) setEmail(value);
        else if (label === I18n.enter_phone_number) setPhone(value);

        setErrors(prevErrors => {
            const updatedErrors = {...prevErrors};

            if (updatedErrors[toSnakeCase(label)]) {
                delete updatedErrors[toSnakeCase(label)];
            }

            return updatedErrors;
        });
    };

    return (
        <div>
            <CustomContainer className="addScreenMainBox createCutomerContainer">
                <Header
                    type="draftHeader"
                    title={I18n.back}
                    backAction={backAction}
                    saveCta={{
                        title: I18n.send,
                        action: () => handleSend(),
                        saveLoad: loading,
                    }}
                />

                <Row className="justify-content-md-center">
                    <Col md={4}>
                        <div>
                            <p className="fontSize24 textCenter fontWeight600 marBot20 marTop0" style={{color: theme.white}}>
                                POS login access
                            </p>
                            <p className="fontSize20  fontWeight400 marBot10 marTop40" style={{color: theme.white}}>
                                Send member login credentials to email or phone
                            </p>
                            <p className="fontSize12  fontWeight400 marBot15" style={{color: theme.darkGrayTwo}}>
                                Send this member login credentials to email or phone number with instructions on how to sign in to the Oscar.
                            </p>

                            <TextField
                                // type="email"
                                onChange={onChange}
                                error={errors?.['enter_email_address']}
                                label={I18n.enter_email_address}
                                placeholder={I18n.enter_email_address}
                                value={email}
                            />

                            <TextField
                                // type="email"
                                onChange={onChange}
                                label={I18n.enter_phone_number}
                                placeholder={I18n.enter_phone_number}
                                value={phone}
                                maxLength={11}
                            />
                        </div>
                    </Col>
                </Row>
            </CustomContainer>
        </div>
    );
};

export default SendEmail;
